<template>
  <div>
    <div id="success-hint">Note stored successfully.</div>

    <div id="error-hint">Note could not be saved. Please try again later.</div>

    <div id="deletion-confirmation-modal">
      <div id="modal-text-wrapper" style="margin: 1rem 1rem 0px 1rem">
        Are you sure you want to delete this note?
      </div>

      <div
        id="modal-button-wrapper"
        style="
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          justify-content: space-around;
          -webkit-justify-content: space-around;
          margin: 1rem 0px;
        "
      >
        <button class="button-large" @click="hideConfirmationModal()">
          Cancel
        </button>
        <button class="button-large" @click="deleteNote()">Ok</button>
      </div>
    </div>

    <Header
      id="header"
      v-on:show-sign-up-modal="showSignUpModal()"
      v-on:show-sign-in-modal="showSignInModal()"
    />

    <SignUp id="sign-up" />
    <SignIn id="sign-in" />
    <SignOut id="sign-out" />

    <router-view />
    
    <Footer id="footer" />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { saveData } from "./firebase-helpers.js";
import { defaultNote } from "./store";
import store from "./store";
import SignUp from "./components/SignUp.vue";
import SignIn from "./components/SignIn.vue";
import SignOut from "./components/SignOut.vue";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export default {
  name: "App",
  components: {
    SignUp,
    SignIn,
    SignOut,
    Header,
    Footer,
  },

  data() {
    return {
      noteToBeDeleted: null,
    };
  },

  created() {
    document.title = "YetAnotherInsaneNotes.App";

    const html = document.documentElement
    html.setAttribute('lang', 'en')

    /*
    const auth = getAuth();
    signInWithEmailAndPassword(auth, "ptrcsauer@gmail.com", "123456")
      .then((userCredential) => {
        store.commit("login", userCredential.user);
        loadNotes();
        store.commit("setActiveNote", { ...defaultNote });
        let el = document.getElementById("sign-in");
        el.style.display = "none";
      })
      .catch((error) => {});
      */
  },

  methods: {
    saveNoteKeyPressed(e) {
      console.log("save note key pressed");
      console.log(
        "store.state.activeNote === this.defaultNote",
        store.state.activeNote === defaultNote
      );

      if (!(e.keyCode === 83 && (e.ctrlKey || e.metaKey))) {
        return;
      }

      e.preventDefault();
      this.saveNote();
    },

    showSignUpModal() {
      let el = document.getElementById("sign-up");
      el.style.display = "inline";
    },

    showSignInModal() {
      let el = document.getElementById("sign-in");
      el.style.display = "inline";
    },

    saveNote() {
      console.log("save note");
      store.state.activeNote.timestamp = Date.now();
      const noteIndex = store.state.notes.findIndex(
        (note) => note.id === store.state.activeNote.id
      );

      if (noteIndex < 0) {
        console.log("adding new note");
        store.commit("addNote", store.state.activeNote);
      } else {
        console.log("updating existing note");
        store.commit("updateNote", store.state.activeNote);
      }
      saveData("save");
    },

    openConfirmationModal(note) {
      console.log("opening modal");

      this.noteToBeDeleted = note;

      console.log(this.noteToBeDeleted);

      const el = document.getElementById("deletion-confirmation-modal");
      el.style.display = "flex";
      el.style.flexDirection = "column";
    },

    hideConfirmationModal() {
      console.log("hiding modal");
      const el = document.getElementById("deletion-confirmation-modal");
      el.style.display = "none";
    },

    deleteNote() {
      store.commit("removeNote", this.noteToBeDeleted);
      saveData("delete");

      if (this.noteToBeDeleted.id === store.state.activeNote.id) {
        store.commit("setActiveNote", { ...defaultNote });
      }

      this.hideConfirmationModal();
    },

    async writetodb() {
      store.commit("addNote", {
        id: null,
        title: Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, ""),
        content: Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, ""),
        tags: [],
        timestamp: Date.now(),
      });

      saveData("save");

      return;

      /*
      console.log(db);
      try {
        const docRef = await addDoc(collection(db, "users"), {
          userData: "some user data",
          notes: [
            {
              title: "title 1",
              content: "content 1",
              tags: ["tag 1", "tag 2", "tag 3"],
              timestamp: Date.now(),
            },
            {
              title: "title 2",
              content: "content 2",
              tags: ["tag 4", "tag 3"],
              timestamp: Date.now(),
            },
          ],
        });
        console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
      }

      const docRef = doc(db, "users", "Sb3VdDnJUV7AMkCjw6R2");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data read:", docSnap.data().notes);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
      */
    },
  },
};
</script>

<style>
* {
  --warning-background-color: hsl(174, 72%, 76%);
  --warning-text-color: hsl(174, 72%, 36%);
  --consent-background-color: var(--warning-background-color);
  --consent-shadow-color: var(--warning-text-color);

  --btn-text-color: hsl(174, 72%, 76%);
  --btn-color: hsl(174, 72%, 36%);
  --btn-color-hover: hsl(174, 72%, 46%);
  --btn-color-active: hsl(174, 72%, 56%);
  
  --btn-decline-text-color: hsl(174, 72%, 16%);
  --btn-decline-color: hsl(174, 72%, 56%);
  --btn-decline-color-hover: hsl(174, 72%, 46%);
  --btn-decline-color-active: hsl(174, 72%, 36%);
}

html, body {
    height: 100%;
}

body {
  background: linear-gradient(
      148deg,
      hsl(174, 72%, 76%) 0%,
      hsl(174, 72%, 36%) 100%
    )
    no-repeat;
    background-attachment: fixed;
  margin: 0;
  padding: 0 1.5rem;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
}

h1 {
  text-transform: uppercase;
}

.button-small {
  margin-left: 5px;
}

.button-large {
  text-transform: uppercase;
  margin-left: 1rem;
  border: 0px;
  border-radius: 10px;
  padding: 5px 10px;
}

#success-hint {
  position: absolute;
  transform: translateX(-50%);
  z-index: 10;
  padding: 1rem 1rem;
  width: fit-content;

  background-color: hsl(174, 72%, 96%);
  display: none;
  border-radius: 10px;
}

#success-hint.show {
  display: inline;
  -webkit-animation: fadein 0.5s, fadeout 0.75s 2.5s;
  animation: fadein 0.5s, fadeout 0.75s 2.5s;
}

#error-hint {
  position: absolute;
  transform: translateX(-50%);
  z-index: 10;
  padding: 1rem 1rem;
  width: fit-content;

  background-color: hsl(174, 72%, 16%);
  display: none;
  border-radius: 10px;
}

#error-hint.show {
  display: inline;
  -webkit-animation: fadein 0.5s, fadeout 0.75s 2.5s;
  animation: fadein 0.5s, fadeout 0.75s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

#deletion-confirmation-modal,
#sign-up,
#sign-in,
#sign-out {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
  background-color: hsl(174, 72%, 36%);
  border-radius: 10px;
  padding: 0px 1rem;
  z-index: 100;
}

#main {
  display: flex;
  display: -webkit-flex;
  padding-bottom: 1.75rem;
}

#notes-list {
  width: 20%;
  height: 100vh;
}

#note {
  width: 80%;
}

input {
  background-color: hsl(174, 72%, 76%);
  border: 0px;
  border-radius: 100px;
  padding: 2px 5px;
}

textarea {
  background-color: hsl(174, 72%, 76%);
  border: 0px;
  border-radius: 100px;
  padding: 2px 5px;
}

@media (min-width: 931px) {
  #notes-list {
    overflow-y: auto;
  }
}

@media (max-width: 930px) {
  #notes-list {
    width: 30%;
  }

  #header {
    margin: 3rem 1rem 1rem 1rem;
  }
}

@media (max-width: 650px) {
  #notes-list {
    width: 40%;
  }
}

@media (max-width: 530px) {
  #notes-list {
    width: 50%;
  }
}

@media (max-width: 430px) {
  #notes-list {
    width: 100%;
    z-index: 5;
  }

  #note {
    display: none;
  }

  #show-notes-list-button {
    display: none;
  }

  #notes-list {
    margin-top: 1rem;
  }

  #new-note-button-mobile {
    display: inline;
    margin-bottom: 1rem;
  }

  #new-note-button {
    display: none;
  }
}

button {
  color: #2c3e50;
}
</style>
